import { render, staticRenderFns } from "./LangBtn.vue?vue&type=template&id=64431482&scoped=true&"
import script from "./LangBtn.vue?vue&type=script&lang=js&"
export * from "./LangBtn.vue?vue&type=script&lang=js&"
import style0 from "./LangBtn.vue?vue&type=style&index=0&id=64431482&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64431482",
  null
  
)

export default component.exports